module.exports = __webpack_public_path__ + "img/img_pj_ skill_brand@3x.2a2e15fc.png";